import type { ServerRegistrationModule } from './ServerRegistrationModule.types';

export default {
  addListener: () => {},
  removeListeners: () => {},
} as ServerRegistrationModule;
